import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  paper: {
    position: 'absolute',
    maxWidth: 600,
    minHeight: 300,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4, 8, 8),
    ...theme.typography.specialGradient,
    color: 'white'
  },
  button: {
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    }
  },
  modal: {
    backgroundColor: 'rgba(240, 199, 75, 0.5)'
  },
  input: {
    '& .MuiFormLabel-root': {
      color: 'white'
    },
    '& .MuiOutlinedInput-root': {
      '& input': {
        color: 'white'
      },
      '& fieldset': {
        borderColor: 'white'
      },
      '&:hover fieldset': {
        borderColor: 'white'
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main
      },
    },
  },
  loading: { height: '100%' }
}))